import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useStickyBottomShadow } from '../../../hooks'
import Button from '../../Button'
import { ModalResizeButton } from '../../Modal'
import { useEmailDraft } from '../Email.hooks'
import { EmailCreationFormActions } from '../EmailCreationFormActions'

import * as styles from './EmailReplyFormActions.module.css'

import DeleteIcon from '../../../icons/delete.svg'

function EmailReplyFormActions({
  MakeFormFullScreenButton = ModalResizeButton,
  containerProps: {
    uploadProps: containerUploadProps,
    ...containerProps
  } = EMPTY_OBJECT,
  isMobileActions,
  onMakeFormFullScreen,
  onRemoveDraft,
  ...restProps
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { draft: emailDraft } = useEmailDraft()

  const { isStuck, ref: stickyRef } = useStickyBottomShadow()

  function handleClickMakeFormFullScreen() {
    onMakeFormFullScreen(values)
  }

  const className = classNames(styles.EmailReplyFormActions, {
    [styles.stuck]: isStuck,
  })

  return (
    <EmailCreationFormActions
      {...restProps}
      containerProps={{
        ...containerProps,
        uploadProps: { ...containerUploadProps, className, ref: stickyRef },
      }}
      isMobileActions={isMobileActions}
    >
      {!isMobileActions ? (
        <div className={styles.buttons}>
          {emailDraft ? (
            <Button.Icon
              isGrey
              Icon={DeleteIcon}
              tooltip={t('Email.ReplyFormRemoveDraftButtonTooltipKey')}
              onClick={onRemoveDraft}
            />
          ) : null}
          {MakeFormFullScreenButton ? (
            <MakeFormFullScreenButton onClick={handleClickMakeFormFullScreen} />
          ) : null}
        </div>
      ) : null}
    </EmailCreationFormActions>
  )
}

export default EmailReplyFormActions
